import { width } from "@grindex-common/helpers/domManipulation";
import { $elementChild } from "@grindex-common/helpers/elements";
import { videoRenderer } from "@grindex-common/helpers/videoRenderer";

function init($views) {
	const $slideMargin = 11;
	const $slideWidth = 64;
	const MAX_SLIDES = 5;
	const MIN_SLIDES = 1;

	$views.forEach(($view) => {
		let $maxSlideCount = MAX_SLIDES;

		const $featuredImage = $view.querySelector(".featured-image img");
		const $container = $view.querySelector(".featured-image");

		let windowWidth;
		let $thumbnailSlider;

		setWindowSize();
		configureThumbnailSlider();
		initializeFirstVideo();
		createEventListeners();

		function calculateMaxSlideCount() {
			const totalSlidesWidth = $slideWidth + $slideMargin;
			const availableWidth = windowWidth - 64;

			if (windowWidth < 1024) {
				const calculatedSlideCount = Math.floor(availableWidth / totalSlidesWidth);
				$maxSlideCount = Math.max(calculatedSlideCount, MIN_SLIDES);
			} else {
				$maxSlideCount = MAX_SLIDES;
			}
		}

		function buildThumbnailSliderConfig() {
			calculateMaxSlideCount();
			return {
				auto: false,
				infiniteLoop: false,
				slideWidth: $slideWidth,
				slideMargin: $slideMargin,
				minSlides: 2,
				maxSlides: $maxSlideCount,
				pager: false,
				hideControlOnEnd: true,
				moveSlides: 1,
				video: true,
				onSliderLoad: function () {
					$(".video-thumbnails > li").removeClass("selected");
					$(".video-thumbnails > li:first").addClass("selected");
					$(".thumbnail-slider .bx-wrapper").css("visibility", "visible");
				},
			};
		}

		function configureThumbnailSlider() {
			const config = buildThumbnailSliderConfig();
			if ($thumbnailSlider && $thumbnailSlider.length) {
				// If the slider has already been initialized, destroy it first.
				$thumbnailSlider.destroySlider();
			}

			// Initialize the slide
			$thumbnailSlider = $("ul.video-thumbnails").bxSlider(config);
		}

		function initializeFirstVideo() {
			videoRenderer.renderOverlayVideo($featuredImage.getAttribute("data-key"), $featuredImage.dataset.videoPlayerId, $container);
		}

		function setWindowSize() {
			windowWidth = width(document.body);
		}

		function setSelected($thumbnail) {
			$view.querySelectorAll("ul > li").forEach(($li) => {
				$li.classList.remove("selected");
			});

			$thumbnail.classList.add("selected");
		}

		function selectContent(e) {
			// the trick here is that IE10 doesn't recognize the click on the overlay but on the img
			const $parentElement = e.currentTarget.parentElement;

			const $thumbnail = $elementChild($parentElement, "image");

			if ($parentElement.classList.contains("selected")) {
				// don't selected a video / image twice
				return false;
			}

			setSelected($parentElement);

			if ($thumbnail.dataset.key) {
				// If rendered before, remove it
				const videoId = `#botr_${$thumbnail.dataset.key}_${$thumbnail.dataset.videoPlayerId}_div`;
				const $existingVideo = document.getElementById(videoId);

				if ($existingVideo) {
					$existingVideo.remove();
				}

				videoRenderer.renderOverlayVideo($thumbnail.dataset.key, $thumbnail.dataset.videoPlayerId, $($container));
			}
		}

		function createEventListeners() {
			const $images = $view.querySelectorAll(".video-thumb");
			const $overlays = $view.querySelectorAll(".overlay");
			$images.forEach(($image) => {
				$image.addEventListener("click", function (e) {
					selectContent(e);
				});
			});

			$overlays.forEach(($overlay) => {
				$overlay.addEventListener("click", function (e) {
					selectContent(e);
				});
			});
		}
	});
}

export default {
	view: "videothumbnailcarousel",
	init,
};
